import client from "./client";
import type { MetricDefinition, MetricInput } from "../types/metrics";

export const metricsApi = {
  list: () => client.get<MetricDefinition[]>("/metrics"),
  get: (id: string) => client.get<MetricDefinition>(`/metrics/${id}`),
  create: (data: MetricInput) => client.post<MetricDefinition>("/metrics", data),
  update: (id: string, data: Partial<MetricInput>) => client.put<MetricDefinition>(`/metrics/${id}`, data),
  remove: (id: string) => client.delete(`/metrics/${id}`),
  preview: (sql: string, datasourceKey?: string | null, config?: import("axios").AxiosRequestConfig) =>
    client.post<{ rows: Record<string, unknown>[] }>("/metrics/preview", {
      sql,
      datasource_key: datasourceKey ?? null,
    }, config),
};
